<template>
  <!-- Table List -->
  <v-list
    class="py-0"
  >
    <v-list-item-group
      :value="selected"
      active-class="primary--text"
      @change="selectedChange"
    >
      <template v-for="[slot, reservationsForSlot] in reservationsByTime.entries()">
        <guest-list-header-row
          :key="slot"
          :title="$localized.hourMinTextFrom24hr(slot)"
        />
        <div
          :key="`grp-${slot}`"
          class="gp-guest-list-group"
        >
          <template v-for="(reservation, i) in reservationsForSlot">
            <guest-list-row
              :key="reservation.id"
              class="gp-guest-list"
              :reservation="reservation"
              :waitlist-list-order="waitingListOrderForReservation.get(reservation.id)"
              :overbooked-tab-items="overbookedTabItemsForReservation.get(reservation.id)"
              unread-reservations
              :compact="$vuetify.breakpoint.xsOnly"
            />
            <v-divider
              :key="`${slot}_${i}`"
            />
          </template>
        </div>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script lang='ts'>

import Vue, { PropType } from 'vue';
import Reservation from '@/model/Reservation';
import { mapActions } from 'vuex';
import { tryEditReservation, tryCloseEditReservation } from '@/services/reservation-edit-utils';
import { isOngoingReservation } from '@/services/reservation-utils';
import GuestListRow from './GuestListRow.vue';
import GuestListHeaderRow from './GuestListHeaderRow.vue';

export default Vue.extend({
  name: 'GuestList',
  components: { GuestListRow, GuestListHeaderRow },
  props: {
    reservationsByTime: { type: Map as PropType<Map<string, Reservation[]>>, required: true },
  },
  data: () => ({
    selected: undefined as undefined | number,
  }),
  computed: {
    edited(): number | undefined {
      return this.$tstore.getters.editReservation?.id;
    },
    waitingListOrderForReservation(): Map<number, number> {
      const orderForWaitingReservation = this.$tstore.getters.orderForWaitingReservation as Map<number, number>;
      return orderForWaitingReservation;
    },
    overbookedTabItemsForReservation(): Map<number, Set<number>|undefined> {
      return this.$tstore.getters.dayOverbookedTabItemsForReservationId;
    },
  },
  watch: {
    edited() {
      this.selected = this.edited;
    },
  },
  mounted() {
    this.selected = this.$tstore.getters.editReservation?.id;
  },
  methods: {
    async selectedChange(reservationId: number | undefined) {
      this.selected = reservationId;

      const { reservationsById } = this.$tstore.state.reservations;
      const reservation = reservationId ? reservationsById[reservationId] : undefined;
      if (reservation === undefined) await tryCloseEditReservation();
      else {
        await tryEditReservation(this.$router, reservation);
      }
    },
  },
});

</script>

<style lang="scss">

  .gp-guest-list-group div.gp-guest-list:nth-of-type(even)  {
    background-color: $grey-2-color;
    .theme--dark & {
      background-color: $grey-90-color;
    }
  }

</style>
